/// <reference types="@types/dom-mediacapture-record" />
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MediaRecorder } from "extendable-media-recorder";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from "ngx-toastr";
import { UserApiService } from "src/app/services/user.api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-user-verification",
  templateUrl: "./user-verification.component.html",
  styleUrls: ["./user-verification.component.scss"],
})
export class UserVerificationComponent implements OnInit {
  @ViewChild("onboardingAlert", { static: true }) onboardingAlert: ElementRef;
  userId;
  mediaRecorder;
  chunks = [];
  onStart: boolean = false;
  onStop: boolean = true;
  start = document.getElementById("btnStart");
  stop = document.getElementById("btnStop");
  mediaStream = null;
  formData = new FormData();
  videoBlob;
  video_status = true;
  // chunks: Array<any> = [];

  constraintObj = { audio: true, video: { width: { min: 320, ideal: 320, max: 320 }, height: { min: 240, ideal: 240, max: 240 }, framerate: 40 } };

  // geolocation
  errorMessage: string = "";
  latitude: number;
  longitude: number;

  media_status = false;
  constructor(
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    private userApi: UserApiService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) {}

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (val) => {
          this.setLocation(val);
        },
        (er) => {
          this.errHandleLocation(er);
        }
      );
    }
  }

  setLocation(pos) {
    let lat = pos.coords.latitude;
    let long = pos.coords.longitude;
    this.latitude = lat;
    this.longitude = long;
  }

  errHandleLocation(err) {
    switch (err.code) {
      case err.PERMISSION_DENIED:
        this.errorMessage =
          "Aaddress-KYC doesn't have the permission to make use of location services. \n Please clear the browser cache and allow location services for Aaddress-KYC and reload the page.";
        break;
      case err.POSITION_UNAVAILABLE:
        this.errorMessage = "The location of the device is uncertain";
        break;
      case err.TIMEOUT:
        this.errorMessage = "The request to get user location timed out";
        break;
      case err.UNKNOWN_ERROR:
        this.errorMessage = "Time to fetch location information exceeded the maximum timeout interval";
        break;
    }
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.userId = params.get("id");
    });

    let navigatorCopy = navigator as any;
    if (navigatorCopy.mediaDevices === undefined) {
      navigatorCopy.mediaDevices = {};
      navigatorCopy.mediaDevices.getUserMedia = function (constraintObj) {
        let getUserMedia = navigatorCopy.webkitGetUserMedia || navigatorCopy.mozGetUserMedia;
        if (!getUserMedia) {
          return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
        }
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraintObj, resolve, reject);
        });
      };
    } else {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.forEach((device) => {
            console.log(device.kind.toUpperCase(), device.label);
          });
        })
        .catch((err) => {
          console.log(err.name, err.message);
        });
    }

    this.getLocation();
    this.initialSetup();
  }
  initialSetup() {
    let body = { user_id: this.userId };
    this.loader.start();
    this.userApi
      .getUserById(body)
      .then((response) => {
        console.log(body);
        this.media_status = response.media ? true : false;
        this.loader.stop();
      })
      .catch((error) => {
        this.toastr.error(error);
        this.loader.stop();
      });
  }
  btnStart() {
    navigator.mediaDevices
      .getUserMedia(this.constraintObj)
      .then((mediaStreamObj) => {
        this.mediaStream = mediaStreamObj;
        //connect the media stream to the first video element
        let video = document.querySelector("video");
        if ("srcObject" in video) {
          video.srcObject = mediaStreamObj;
        }
        video.onloadedmetadata = function (ev) {
          //show in the video element what is being captured by the webcam
          video.play();
          video.muted = true;
        };
        if (typeof MediaRecorder.isTypeSupported == "function") {
          /*
            MediaRecorder.isTypeSupported is a function announced in https://developers.google.com/web/updates/2016/01/mediarecorder and later introduced in the MediaRecorder API spec http://www.w3.org/TR/mediastream-recording/
          */
          if (MediaRecorder.isTypeSupported("video/webm;codecs=vp9")) {
            var options = { mimeType: "video/webm;codecs=vp9" };
          } else if (MediaRecorder.isTypeSupported("video/webm;codecs=h264")) {
            var options = { mimeType: "video/webm;codecs=h264" };
          } else if (MediaRecorder.isTypeSupported("video/webm")) {
            var options = { mimeType: "video/webm" };
          } else if (MediaRecorder.isTypeSupported("video/mp4")) {
            var options = { mimeType: "video/mp4" };
          }
          console.log("Using " + options.mimeType);
          this.mediaRecorder = new MediaRecorder(mediaStreamObj, options);
        } else {
          console.log("isTypeSupported is not supported, using default codecs for browser");
          this.mediaRecorder = new MediaRecorder(mediaStreamObj);
        }
        // this.mediaRecorder = new MediaRecorder(mediaStreamObj, { mimeType: '' });
        this.mediaRecorder.start();
        this.onStart = true;
        this.mediaRecorder.ondataavailable = (ev) => {
          this.chunks.push(ev.data);
          let blob = new Blob(this.chunks, { type: this.mediaRecorder.mimeType });
          this.chunks = [];
          let videoURL = window.URL.createObjectURL(blob);
          let vidSave = <HTMLVideoElement>document.getElementById("vid2");
          vidSave.src = videoURL;
          this.videoBlob = blob;
        };
      })
      .catch(function (err) {
        console.log(err.name, err.message);
        if (err.name === "NotReadableError") {
          alert("Please Check another application maybe using the Webcam!");
        } else if (err.name === "NotAllowedError") {
          alert("Please check your Camera and Microphone Permissions!");
        }
      });
  }

  btnStop() {
    let video = <HTMLVideoElement>document.getElementById("vid1");
    // video.pause();
    // video.src = null;
    this.mediaRecorder.stop();
    this.onStart = false;
    this.onStop = false;
    const tracks = this.mediaStream.getTracks();
    tracks.forEach((track) => track.stop());
  }

  recordingPlay() {
    const vidSecond = <HTMLVideoElement>document.getElementById("vid2");
    vidSecond.play();
  }

  submitRecording() {
    this.formData.append("user_id", this.userId);
    this.formData.append("media", this.videoBlob);
    this.formData.append("latitude", this.latitude.toString());
    this.formData.append("longitude", this.longitude.toString());
    this.loader.start();
    this.userApi
      .submitRecording(this.formData)
      .then((result) => {
        this.loader.stop();
        this.toastr.success("Media Submitted Successfully");
        this.video_status = true;
        // this.router.navigate(['/thank-you']);
        this.media_status = true;
        this.changetab("Onboarding");
        this.formData = new FormData();
      })
      .catch((err) => {
        this.loader.stop();
        this.toastr.error(err);
        this.formData = new FormData();
      });
  }
  changetab(label): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.media_status) {
        this.video_status = label === "video" ? true : false;
        resolve();
      } else {
        this.modalService.open(this.onboardingAlert, { size: "sm", centered: true }).result.then(
          (result) => {
            resolve();
          },
          (reason) => {
            reject(reason);
          }
        );
      }
    });
  }
}
